import {Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef, OnDestroy} from '@angular/core';
import { MdSelect } from '@angular/material';
import {Subscription} from "rxjs/Subscription";

interface Item {
  Id: number;
  Nombre: string;
}

@Component({
  selector: 'app-md-select-filter',
  templateUrl: './md-select-filter.component.html',
  styleUrls: ['./md-select-filter.component.scss']
})
export class MdSelectFilterComponent implements OnInit, OnDestroy {

  /** Lista para mostrar las opciones del select **/
  private items: Item[] = [];

  /** lista original para restaurar en caso de usar la busqueda **/
  private itemsOriginal: Item[] = [];

  /** Item Seleccionado actualmente **/
  public selectedItem: number = null;

  /** Evento Item Seleccionado **/
  @Output() onItemChanged = new EventEmitter<Item>();

  /** Valor anterior para restaurar en caso de que se borre el valor mientras se está filtrando **/
  private selectedItemPreviousValue: number = null;

  /** Valor de la busqueda **/
  private searchString = '';

  /** Flag para indicar si cambio la seleccion o no**/
  private itemChanged = false;

  /** Referencia al Input para hacer focus al mismo **/
  @ViewChild ('searchInput') searchInput: ElementRef;

  /** Referencia al MatSelect para acceder al scroll **/
  @ViewChild('mainSelect') selectElem: MdSelect;

  @Input()
  set ItemsList(val: Item[]) {
    if (val.length) {
      this.items = val;
      this.itemsOriginal = val;
      if (this.autoSelect) {
        this.selectedItem = this.items[0].Id;
      }
    }
  }

  /** Seleccionar por defecto el primer valor de la lista **/
  @Input() autoSelect = false;

  /** Habilitar el filtro de búsqueda **/
  @Input() filter = true;

  /** Marcar como Disabled **/
  @Input() disabled = false;

  /** Clase para colocar un icono a la izquierda del selector: Ej: zmdi-check **/
  @Input() iconClass = '';

  /** Evento Scroll **/
  private scroll;

  /** Flag para permitir que se haga focus automatico al Input **/
  private allowFocus = true;

  /** Open Close Suscriptions **/
  private onOpenSubscription: Subscription;
  private onCloseSubscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.onOpenSubscription = this.selectElem.onOpen.subscribe(() => this.subscribeToScrollEvent());
    this.onCloseSubscription = this.selectElem.onClose.subscribe(() => this.scroll = null);
  }

  ngOnDestroy() {
    this.onOpenSubscription.unsubscribe();
    this.onCloseSubscription.unsubscribe();
  }

  subscribeToScrollEvent() {
    const panel = window.document.querySelector('.mat-select-panel');
    this.scroll = panel.addEventListener('scroll', event => this.onPanelScroll(event));
  }

  onPanelScroll(e) {
    /** Si el input del buscador no se ve, previene hacer click en las opciones de mas abajo (a las cuales se accede haciendo scroll)
     * mediante la funcion OnBlur, pero requiere un focus constante cuando se cambian los valores del select dado que pierde el focus al cambiar
     * las opciones...
     * Un poco agarrado de los pelos, pero cuando estamos escribiendo (y con el input visible) hacemos focus constante al input para poder escribir normalmente
     * si hacemos scroll, evitamos que se haga focus automatico al generar un blur en el input (es decir al seleccionar una opcion de las de abajo)**/

    this.allowFocus = e.target.scrollTop <= 45;
  }

  onBlur() {
    // cuando tipeamos en el input y las opciones del select cambian, se pierde el focus en el input, si está permitido, restablecemos el focus
    if (this.allowFocus) {
      this.searchInput.nativeElement.focus();
    }
  }

  onItemSelected(e) {
    // marcamos que el acopio cambio para manejar el evento de cierre que se ejecuta luego de este
    // aplicamos la seleccion del item pues en relidad aun la variable no cambio y se emite el evento antes de dicho cambio
    this.selectedItem = e.value;
    this.itemChanged = true;
    this.searchString = '';
    this.items = this.itemsOriginal;
    this.onItemChanged.emit(this.itemsOriginal[this.itemsOriginal.findIndex(x => x.Id === this.selectedItem)]);
  }

  onItemSearch() {
    if (this.searchString.trim().length) {
      this.items = this.itemsOriginal.filter(x => x.Nombre.toLowerCase().includes(this.searchString.trim().toLowerCase()));
    } else {
      this.items = [...this.itemsOriginal];
    }
    setTimeout(_ => this.searchInput.nativeElement.focus());
  }

  toggledSelect(state) {
    if (state) {
      // cuando abrimos las opciones inicializamos las variables para detectar cambios de valores y hacemos focus al filtro
      this.itemChanged = false;
      this.selectedItemPreviousValue = this.selectedItem;
      this.searchInput.nativeElement.focus();
    } else {
      // si el selector no cambió
      if (!this.itemChanged) {
        // revisamos que la opcion previa esté dentro de las opciones, si no es asi, se realizo una busqueda y
        // al no aparecer la opcion actual en el resultado, se elimina del select. Si esto sucede, restauramos la opcion previa
        if (this.items.findIndex(x => x.Id === this.selectedItemPreviousValue) === -1) {
          this.selectedItem = this.selectedItemPreviousValue;
        }
      }
      // restauramos la lista y reiniciamos el input
      this.searchString = '';
      this.items = this.itemsOriginal;
    }
  }

  public clearAllData() {
    this.items = [];
    this.itemsOriginal = [];
    this.selectedItem = null;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/md-select-filter/md-select-filter.component.ts